/**
 * @file activity-log.service.ts
 * @module app/modules/activity-logs/services/activity-log.service
 * @description Thin API-call wrapper for the unified Activity Logs report, backed by
 * the `audit_logs` collection (`_auditLog/admin/logs`).
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.1
 * @version 1.3.5
 */

import APICallService from "../../../../api/apiCallService";
import { activityLogsEndPoints } from "../../../../api/apiEndPoints";
import { ActivityLogs } from "../../../../utils/constants";
import { IFetchActivityLogsParams } from "../types/activity-log.types";

/**
 * Fetches platform/action dropdown options from the backend, mirroring
 * GlobalPlatformProjectTypes/GlobalPlatformLogsTypes (utrade-backend CommonConstants.js)
 * so the frontend never has to hardcode/duplicate these enums.
 */
export const fetchActivityLogFilters = async () => {
  const apiService = new APICallService(
    activityLogsEndPoints.filters,
    {},
    "",
    "",
    "",
    "",
    ActivityLogs,
  );
  return apiService.callAPI();
};

/**
 * Fetches paginated `audit_logs` records for the unified Activity Logs report.
 */
export const fetchActivityLogs = async (params: IFetchActivityLogsParams) => {
  const queryParams: any = {
    pageNo: params.pageNo,
    limit: params.limit,
    sortKey: "_createdAt",
    sortOrder: -1,
    needCount: true,
    skip: params.skip ?? 0,
    searchTerm: params.searchTerm ?? "",
  };
  if (params.platform) queryParams.platform = params.platform;
  if (params.logType) queryParams.logType = params.logType;
  if (params.type) queryParams.type = params.type;
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.variantId) queryParams.variantId = params.variantId;
  if (params.userId) queryParams.userId = params.userId;

  const apiService = new APICallService(
    activityLogsEndPoints.list,
    queryParams,
    "",
    "",
    "",
    "",
    ActivityLogs,
  );
  return apiService.callAPI();
};
